<template>
  <Layout>
    <div class="card">
      <div class="card-body">
        <PageHeader :title="title" :items="items" />
        <div class="form-row">
          <div class="form-group col-md-6">
            <label>Filtro de estado</label>
            <select class="form-control big-font" v-model="filtro.estado" @change="loadItems()">
              <option value="0">En espera</option>
              <option value="1">Procesado</option>
              <option value="2">Observado</option>
            </select>
          </div>

          <div class="form-group col-md-4">
            <label>Nombres</label>
            <input type="text" class="form-control" v-model="filtro.busqueda" />
          </div>
          <div class="form-group col-md-2">
            <button type="button" class="btn btn-primary mt-4" v-on:click="loadItems">Buscar</button>
          </div>
        </div>

        <vue-good-table
          ref="tblTramiteExterno"
          mode="remote"
          @on-page-change="onPageChange"
          @on-sort-change="onSortChange"
          @on-column-filter="onColumnFilter"
          @on-per-page-change="onPerPageChange"

          :totalRows="totalRecords"
          :isLoading.sync="isLoading"
          :pagination-options="{
            enabled: true
          }"
          :rows="rows"
          :columns="columns"
          @on-row-dblclick="onRowDoubleClick"
          styleClass="vgt-table smalltable fixfont"

          :select-options="{
            selectOnCheckboxOnly: true,
            enabled: true,
            selectionText: 'Filas seleccionadas',
            clearSelectionText: 'Borrar'
          }"
          :sort-options="{
          enabled: false,
          }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'tipo_expediente'">
              <a href="javascript:void(0);" v-on:click="mostrarModal(props.row.id)">{{props.row.tipo_expediente}}</a>
            </span>

            <span v-if="props.column.field == 'resolucion_archivo_'">
              <div
                      v-if="props.row.resolucion_archivo"
                      style="float:left"
              >
                <a :href="server + '/storage/' + props.row.resolucion_archivo.nombre" target="_blank" v-b-tooltip.auto ="props.row.resolucion_archivo.nombre_original" >
                  <i
                          class="mdi mdi-cloud-download ml-1"
                          style="font-size: 20px;color: #000000"
                  /></a>
              </div>
            </span>
            <span v-if="props.column.field == 'oficio_archivo_'">
              <div
                      v-if="props.row.oficio_archivo"
                      style="float:left"
              >
                <a :href="server + '/storage/' + props.row.oficio_archivo.nombre" target="_blank" v-b-tooltip.auto ="props.row.oficio_archivo.nombre_original" >
                  <i
                          class="mdi mdi-cloud-download ml-1"
                          style="font-size: 20px;color: #000000"
                  /></a>
              </div>
            </span>
            <span v-else-if="props.column.field == 'acciones'">
              <button class="btn btn-outline-warning m-1" v-on:click="getModel(props.row)" >
                Editar
              </button>
              <button class="btn btn-outline-info m-1" v-on:click="generarResolucion(props.row)" v-show="!props.row.oficio_archivo" >

                Generar
              </button>

            </span>
            <span v-else class="fixfont">
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>

          <div slot="table-actions">

          </div>
        </vue-good-table>
        <b-modal
                id="modalModel"
                scrollable
                title="Modificar registreo"
                title-class="font-18"
                size="lg"
        >
          <form class="needs-validation" @submit.prevent="formSubmit">
            <b-overlay :show="isLoading" rounded="sm">
              <div class="card">
                <div class="card-body">
                  <div class="form-row big-font">
                    <div class="form-group col-md-12">
                      <label>Estado</label>
                      <select class="form-control big-font" v-model="model.estado" >
                        <option value="0">En espera</option>
                        <option value="1">Procesado</option>
                        <option value="2">Observado</option>
                      </select>
                    </div>
                    <div class="form-group col-md-12">
                      <label>Observación</label>
                      <input class="form-control"
                             v-model="model.observacion"
                             :class="{ 'is-invalid': submitted && $v.model.observacion.$error }"
                             v-tooltip="'Form id de google'"
                      />
                      <div v-if="submitted && $v.model.observacion.$error" class="invalid-feedback">
                        <span v-if="!$v.model.observacion.required">Este valor es requerido.</span>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4"></div>
                    <div class="col-md-4">
                      <b-button block variant="info"  type="submit" >
                        Guardar
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
            </b-overlay>
          </form>

        </b-modal>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {required} from "vuelidate/lib/validators";


/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Resoluciones y oficios de grados",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      razonRechazo:"",
      expedientes_tipos:[],
      title: "Resoluciones y oficios de grados",
      items: [
        {
          text: "Expedientes",
          href: "/"
        },
        {
          text: "Recepción",
          active: true
        }
      ],

      isLoading: false,
      columns: [
        {
          label: "ID SOL",
          field: "idSolicitud"
        },
        {
          label: "Codigo",
          field:"codigo"
        },
        {
          label: "Tarea",
          field:"tarea"
        },
        {
          label: "Solicitante",
          field:"solicitante"
        },
        {
          label: "Carrera",
          field:"carrera"
        },
        {
          label: "Descripcion",
          field: "descripcion"
        },
        {
          label: "Inicio",
          field:"anio_ingreso"
        },
        {
          label: "Final",
          field:"anio_egreso"
        },
        {
          label: "Fecha",
          field:"fecha"
        },
        {
          label: "Resolución",
          field:"resolucion_archivo_"
        },
        {
          label: "Oficio",
          field:"oficio_archivo_"
        },
        {
          label: "Observacion",
          field:"observacion"
        },
        {
          label: "Acciones",
          field:'acciones'
        }
      ],
      rows: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: ""
        },
        page: 1,
        perPage: 10
      },
      server: process.env.VUE_APP_BACKEND,
      modal:{},
      model:{
        estado:"0"
      },
      filtro:{
        estado:"0",
        busqueda:""
      }
    };
  },

  methods: {
    formSubmit() {
      this.submitted = true;
      this.$v.$touch();
      if(this.$v.$error==false){
        this.guardar();
      }
    },

    guardar(){
      this.isLoading = true;
      const url = `${process.env.VUE_APP_BACKEND}/api/tramites-externos/${this.model.id}`;
      this.axios
              .request({
                url,
                method: 'put',
                data: { model: this.model },
              })
              .then(() => {
                  this.$bvModal.hide("modalModel");
                  this.loadItems();

              })
              .catch((err) => {
                this.$swal('error', err.mensaje, 'warning');
              })
              .finally(() => {
                this.isLoading = false;
              });
    },
    generarResolucion(row){
      this.isLoading=true;
      this.axios.get(process.env.VUE_APP_BACKEND + "/api/tramites-externos/generar-resolucion/"+row.id)
              .then(() => {
                this.loadItems();
                this.isLoading = false;
              })
              .catch(() => {
                this.isLoading = false;
                //console.log(error);
              });
    },
    getModel(row){
      this.isLoading=true;
      this.model={
        observacion:"",
        estado:"0"
      };
      this.axios.get(process.env.VUE_APP_BACKEND + "/api/tramites-externos/"+row.id)
              .then((response) => {
                this.model=response.data;
                this.$bvModal.show("modalModel");
                this.isLoading = false;
              })
              .catch(() => {
                this.isLoading = false;
                //console.log(error);
              });
    },
    decimal(value) {
      if (value === null) {
        return "-";
      } else {
        return parseFloat(value).toFixed(2);
      }
    },

    onSearch: function(params) {
      this.updateParams({ page: params.page });
      this.updateParams({ searchTerm: params.searchTerm });
      this.loadItems();
    },
    say: function(message) {
      alert(message);
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems();
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.loadItems();
    },

    onSortChange(params) {
      this.updateParams({
        sort: [
          {
            type: params.sortType,
            field: this.columns[params.columnIndex].field
          }
        ]
      });
      this.loadItems();
    },

    onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },
    // load items is what brings back the rows from server
    loadItems() {
      this.isLoading = true;
      this.serverParams.filtro=this.filtro;
      this.axios
        .get(process.env.VUE_APP_BACKEND + "/api/tramites-externos/tabla", {
          params: this.serverParams
        })
        .then(response => {
          //console.log(response.data.data);
          this.totalRecords = response.data.total_records;
          this.rows = response.data.data;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          //console.log(error);
        });
    },
    /* eslint-disable */
    onRowDoubleClick(params) {
      //this.$bvModal.show("modalExpediente");
      //this.mostrarModal(params.row.id);
    },
    /* eslint-enable */
  },
  mounted() {
    this.loadItems();
  },
  validations: {
    model: {
      descripcion:{required},
    }
  },
};
</script>

<style>
.fixfont {
  font-size: 12px !important;
  color: #000000 !important;
}
</style>
